import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getAuth } from 'firebase/auth'
import { initializeApp } from 'firebase/app'
import { getDatabase, ref, set } from '@firebase/database'


const app = initializeApp({
  apiKey: "AIzaSyAJepTIpCVyrg7p2tc_Z1qUhR2MgiLTc8A",
  authDomain: "waitlist-45344.firebaseapp.com",
  databaseURL: "https://waitlist-45344-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "waitlist-45344",
  storageBucket: "waitlist-45344.appspot.com",
  messagingSenderId: "923601771548",
  appId: "1:923601771548:web:f5d1951abf5b2665d613d9",
  measurementId: "G-KJ19T9VEHN"
})

// Create a transporter using your email service provider's SMTP settings



const firestore = getFirestore(app)
export const db = getDatabase()

export function writeUserData(email,url) {
  set(ref(db, 'users/' + email.replace(/\./g, ',')), {
    email: email,
    url:url
  });
  
}

const storage = getStorage(app)

export const auth = getAuth(app)

export { app, firestore, storage }